import { Component, ContentChild, ViewEncapsulation } from '@angular/core';
import { TmModalComponent } from '../tm-modal/tm-modal.component';

@Component({
  selector: 'tm-modal-body',
  templateUrl: './tm-modal-body.component.html',
  styleUrls: ['./tm-modal-body.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TmModalBodyComponent {
  @ContentChild('tmModalBody', {static: true}) bodyTemp: any;
  constructor(public modal: TmModalComponent) { }
}
